import * as React from 'react'

import { Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { ShiftManagementFeatureFlags } from 'modules/shift_management/lib/consts/ShiftManagementFeatureFlags'

import { SelectWorkPlaceModal } from '../../Body/DataTable/CoverageSection/Body/SelectWorkPlaceModal'
import UpgradeButton from './UpgradeButton'

interface Props {
  hasNoneShiftManagementPlanning: boolean | undefined
  hasCoverageView: boolean
  setShowCoverageSection: (showCoverageSection: boolean) => void
  showCoverageSection?: boolean
}

const ShowCoverageSectionButton = ({
  hasNoneShiftManagementPlanning,
  hasCoverageView,
  setShowCoverageSection,
  showCoverageSection,
}: Props) => {
  const [isTooltipOpen, setIsTooltipOpen] = useToggle(false)
  const [showModal, setShowModal] = React.useState<boolean>(false)

  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const enableLocation = hasFeatureFlag(ShiftManagementFeatureFlags.DEV_SHIFT_MANAGEMENT_AUTOMATION)

  const label = i18n.t('shift_management.coverage_section.tooltip_title')

  useEffect(() => {
    setShowCoverageSection(false)
  }, [])

  const onShowSection = () => {
    if (hasNoneShiftManagementPlanning || !hasCoverageView) return

    if (!showCoverageSection) {
      track(trackingEvents.shiftManagement.goToCoverageSection, {})
    }
    if (enableLocation && !showCoverageSection) {
      setShowModal(!showModal)
      return
    }
    setShowCoverageSection(!showCoverageSection)
  }

  if (hasNoneShiftManagementPlanning) {
    return null
  }

  if (!hasCoverageView)
    return (
      <Tooltip.Alt
        attachment="top center"
        label={label}
        open={isTooltipOpen}
        toggle={setIsTooltipOpen}
      >
        <UpgradeButton
          feature={Features.shift_management_coverage_view}
          setIsTooltipOpen={setIsTooltipOpen}
        />
      </Tooltip.Alt>
    )

  return (
    <>
      <SelectWorkPlaceModal
        onClose={() => setShowModal(false)}
        showModal={showModal}
        setShowCoverageSection={() => setShowCoverageSection(!showCoverageSection)}
      />
      {showCoverageSection ? (
        <Button type="secondary" onClick={onShowSection} iconName="shift-check" />
      ) : (
        <Tooltip.Alt
          attachment="top center"
          label={label}
          open={isTooltipOpen}
          toggle={setIsTooltipOpen}
        >
          <Button type="secondary" onClick={onShowSection} iconName="shift-check" />
        </Tooltip.Alt>
      )}
    </>
  )
}

export default ShowCoverageSectionButton
